import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormLabel
} from "@mui/material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import Grid from "@mui/material/Grid2";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { fetchEmployees } from "../../redux/Slice/employeeSlice";
import { Add } from "@mui/icons-material";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { getAssignLeads } from "../../redux/Slice/assignLeadSlice";
import { createAssignLead, updateAssignLead } from "../../redux/Slice/LeadSlice";


const AssignEmployeeToLead = ({ data, setData }) => {
    const dispatch = useDispatch();
    const params = useParams();
    // console.log("data:",data);
 
    const { leads} = useSelector((state) => state.leads);
    const { employees} = useSelector((state) => state.employee);
    const { assignLeads} = useSelector((state) => state.assignLeads);
    console.log("assignLeads:",assignLeads);
   

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    useEffect(() => {
        dispatch(fetchEmployees());
        dispatch(getAssignLeads());
    }, [dispatch]);


  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedEmployee(null);
    };

    const handleAssignEmployee = () => {
        dispatch(setLoading(true));
        if (selectedEmployee) {
            const formData = { employee_id: selectedEmployee?._id, lead_id: data?._id };
            dispatch(updateAssignLead({ assignLeads_id: data?._id, formData }))
                .unwrap()
                .then(() => {
                    handleCloseDialog();
                    dispatch(setLoading(false));
                })
                .catch((error) => {
                    console.error("Error updating assign lead:", error);
                    dispatch(setLoading(false));
                });
        }
    };

    const handleAssignLead = () => {
      dispatch(setLoading(true));
  
      const formData = {
          lead_id: data._id,
          employee_id: selectedEmployee._id,
      };
  
      dispatch(createAssignLead(formData)).unwrap()
          .then(() => {
  
              handleCloseDialog();  // Close the dialog
              dispatch(setLoading(false));  // Disable the loading state
          })
          .catch((error) => {
              console.error("Error assigning lead:", error);
              dispatch(setLoading(false));
          });
  };
  

    return (
        <>
            <Grid item size={12}>
                <Paper elevation={3} sx={{ p: 2 }}>
                    <Box flexDirection="row" justifyContent="space-between" alignItems="center" display='flex'>
                        <Typography variant="h6">Assigned Employees</Typography>
                        {!data?.current_assignment_employee_id && (
                            <div>
                                <IconButton onClick={handleOpenDialog}>
                                    <Add />
                                </IconButton>
                            </div>
                        )}
                    </Box>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Designation</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone Number</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.current_assignment_employee_id && (
                                    <TableRow >
                                        <TableCell>{data?.current_assignment_employee_id?.name}</TableCell>
                                        <TableCell>{data?.current_assignment_employee_id?.designation}</TableCell>
                                        <TableCell>{data?.current_assignment_employee_id?.email}</TableCell>
                                        <TableCell>{data?.current_assignment_employee_id?.phoneNumber}</TableCell>
                                        <TableCell>
                                            <IconButton aria-label="assign-to-leads" onClick={handleOpenDialog}>
                                                <AssignmentIndIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )}

                                {data?.previous_assignment_employee_ids?.map((employee) => {
                                    return (
                                        <TableRow >
                                            <TableCell>{employee?.name}</TableCell>
                                            <TableCell>{employee?.designation}</TableCell>
                                            <TableCell>{employee?.email}</TableCell>
                                            <TableCell>{employee?.phoneNumber}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>

            <Dialog
                open={isDialogOpen}
                onClose={handleCloseDialog}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        p: 2,
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem", mb: 2 }}>
                    Select an Employee
                </DialogTitle>
                <DialogContent sx={{ maxHeight: "500px", overflowY: "auto", p: 2 }}>
                    <Autocomplete
                        options={employees?.filter(
                            (employee) =>
                                employee._id !== data?.current_assignment_employee_id?._id
                        )}
                        getOptionLabel={(employee) => `${employee.name} (${employee.email})`}
                        value={selectedEmployee}
                        onChange={(event, newValue) => {
                            console.log("newValue:", newValue);
                            setSelectedEmployee(newValue);
                        }}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                id="search"
                                placeholder="Type Search ..."
                                variant="outlined"
                                InputLabelProps={{
                                    sx: {
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                    },
                                }}
                                fullWidth
                            />
                        )}
                        renderOption={(props, option) => (
                            <ListItem {...props} key={option._id}>
                                <ListItemText primary={option?.name} secondary={option?.email} />
                            </ListItem>
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            if (data?.current_assignment_employee_id) {
                                handleAssignEmployee();
                            } else {
                                handleAssignLead();
                            }
                        }}
                        disabled={!selectedEmployee}
                        sx={{
                            color: selectedEmployee ? "#fff" : "#999",
                            "&.Mui-disabled": {
                                bgcolor: "grey.300",
                                color: "grey.500",
                            },
                        }}
                    >
                        Assign
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AssignEmployeeToLead;
